export default __webpack_public_path__ + "static/media/FABLOGO.1af5a114.png";